// Vendors
import $ from 'jquery';

// Style
import '../scss/pip.scss';

// Page specifics
import './pip/landing-page';

// Event Listener/handler
window.addEventListener('wlUpdateUnreadMessages', ({ detail: { data } }) => {
  $('.side-menu__unread-messages').text(data);

  if (parseInt(data) > 0) {
    $('.side-menu__unread-messages').removeClass('u--display-none');
  } else {
    $('.side-menu__unread-messages').addClass('u--display-none');
  }
});
